<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h1>Table of Contents</h1>
<ol>
<li id="level1-titlepage">
<span href="#/titlepage" title="Link target outside of Sample">Title Page</span>
</li>
<li id="level1-toc">
<a href="#/toc">Table of Contents</a>
</li>
<li id="level1-front3">
<a href="#/front01">Copyright</a>
</li>
<li id="level1-front4">
<a href="#/front02">Dedications</a>
</li>
<li id="level1-front5">
<a href="#/front03">Acknowledgments</a>
</li>
<li id="c01">
<a href="#/c01">One</a>
</li>
<li id="c02">
<span href="#/c02" title="Link target outside of Sample">Two</span>
</li>
<li id="c03">
<span href="#/c03" title="Link target outside of Sample">Three</span>
</li>
<li id="level1-back9">
<span href="#/back01" title="Link target outside of Sample">About the Author</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?9c1d795e